import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface FilterState {
  [key: string]: string;
}

const initialState: FilterState = {};

const filterSlice = createSlice({
  name: "filters",
  initialState,
  reducers: {
    updateFilters: (state, action: PayloadAction<{ key: string; value: string }>) => {
      if (action.payload.value.trim() === "") {
        delete state[action.payload.key]; 
      } else {
        state[action.payload.key] = action.payload.value;
      }
    },
    resetFilters: () => ({})
  },
});

export const { updateFilters, resetFilters } = filterSlice.actions;
export default filterSlice.reducer;
